import { Component } from '@angular/core';

@Component({
  selector: 'app-floating-action-bar',
  standalone: true,
  template: `
    <aside class="cg-admin-fab">
      <ng-content select="[info]" />
      <div class="cg-admin-page-header__actions">
        <ng-content select="[actions]" />
      </div>
    </aside>
  `,
})
export class FloatingActionBarComponent {}
